import React from 'react';
import { useObserver } from 'mobx-react-lite';
import LogoGrey from '@assets/icons/logo-grey.svg';

import './EmptyProductsPage.scss';

export const EmptyProductsPage = () => {
    return useObserver(() => (
        <div className="EmptyProductsPage">
            <div className="EmptyProductsPage__content">
                <div className="EmptyProductsPage__text">
                    You don’t have permissions for Wärtsilä Products. <br /> For questions, please contact
                    {` `}
                    <a href="mailto:voyage.support@wartsila.com">voyage.support@wartsila.com</a>
                    <div className="EmptyProductsPage__logo">
                        <img src={LogoGrey} alt="LogoGrey" />
                    </div>
                </div>
            </div>
        </div>
    ));
};
